import type React from 'react';

import Row from 'app/shared/core/Row';
import Button from 'app/shared/core/Button';
import Center from 'app/shared/modules/Center';

interface ErrorModalProps {
  onHidePopup: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ onHidePopup }) => {
  return (
    <div className="ErrorModal">
      <Row size="md">Sorry! Something went wrong on our end.</Row>
      <Row size="md">
        <Center>
          <Button size="md" btnType="primary" onClick={onHidePopup}>
            Go back
          </Button>
        </Center>
      </Row>
    </div>
  );
};

export default ErrorModal;
